/**
 * @generated SignedSource<<938745a89dd74c247d545d374494c3c8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { outOfStock as hubProductOutOfStockResolverType } from "../../../../client-resolvers";
// Type assertion validating that `hubProductOutOfStockResolverType` resolver is correctly implemented.
// A type error here indicates that the type signature of the resolver module is incorrect.
(hubProductOutOfStockResolverType satisfies (
  rootKey: clientResolversOutOfStockFragment$key,
) => boolean | null | undefined);
export type ProductCardFragment$data = {
  readonly id: string;
  readonly outOfStock: boolean | null | undefined;
  readonly priceAmount: number;
  readonly product: {
    readonly brand: {
      readonly id: string;
      readonly name: string;
    };
    readonly category: {
      readonly i18N: any;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly photo: {
      readonly id: string;
      readonly variant: string;
    };
  };
  readonly stock: number;
  readonly " $fragmentType": "ProductCardFragment";
};
export type ProductCardFragment$key = {
  readonly " $data"?: ProductCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCardFragment">;
};

import {outOfStock as hubProductOutOfStockResolver} from '../../../../client-resolvers';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCardFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CloudflareImage",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "variant",
                  "value": "PUBLIC"
                }
              ],
              "kind": "ScalarField",
              "name": "variant",
              "storageKey": "variant(variant:\"PUBLIC\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Brand",
          "kind": "LinkedField",
          "name": "brand",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "i18N",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "fragment": {
        "args": null,
        "kind": "FragmentSpread",
        "name": "clientResolversOutOfStockFragment"
      },
      "kind": "RelayResolver",
      "name": "outOfStock",
      "resolverModule": hubProductOutOfStockResolver,
      "path": "outOfStock"
    }
  ],
  "type": "HubProduct",
  "abstractKey": null
};
})();

(node as any).hash = "73a25d9ee49758d770568a5ff63c575f";

export default node;
